import React, { useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import { BarChart } from "source/components/framework/Chart/BarChart";
import { PieChart } from "source/components/framework/Chart/PieChart";
import { LineChart } from "source/components/framework/Chart/LineChart";
import { Base } from "ui/Scripts/source/framework/base";
import { ITaskTypeChart } from "ui/Scripts/source/models/task/taskTypeChart";
import { ChartValueFormatting, AppChartType } from "ui/Scripts/source/models/enums";
import { ITaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskEditTypeItem, TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { IReportChartDataSet } from "ui/Scripts/source/models/report/reportChartDataSet";

interface IChartDesignerBuilderChartProps {
    taskType: ITaskEditTypeItem;
    taskTypeChart: ITaskTypeChart;
    chartTestDataRows: ITaskDataRow[];
}

interface IChartDesignerBuilderChartState {
    dataId: string;
    labels: string[];
    dataSets: IReportChartDataSet[];
    yAxisValueFormatting: ChartValueFormatting;
}

export const ChartDesignerBuilderChart = (props: IChartDesignerBuilderChartProps) => {
    const legendContainerId = useRef(Base.getGuid());

    const [state, setState] = useState<IChartDesignerBuilderChartState>({
        dataId: "",
        labels: [],
        dataSets: [],
        yAxisValueFormatting: ChartValueFormatting.None
    });

    const getChartDesignerBuilderChartState = (taskTypeChart: ITaskTypeChart): IChartDesignerBuilderChartState => {
        const chartData = TaskEditTypeItem.getTaskTypeChartData(props.taskType, props.taskTypeChart, props.chartTestDataRows);
        return { ...chartData, dataId: state.dataId + 1 };
    };

    useEffect(() => {
        setState(getChartDesignerBuilderChartState(props.taskTypeChart));
    }, [props.taskTypeChart.groupingFields, props.taskTypeChart.valueFields, props.taskTypeChart.taskChartType, props.taskType.formCols, props.taskType.lineCols, props.chartTestDataRows]);

    return (
        <Box style={{ height: "100%" }}>
            <Box display="flex" alignItems="start">
                <Typography
                    variant="subtitle1"
                    fontWeight={600}
                    m=".5rem"
                    color=""
                >
                    {props.taskTypeChart.title}
                </Typography>
            </Box>
            <Box sx={{ width: "100%", height: "400px", position: "relative", padding: "0 1rem 1rem 1rem", display: "flex" }}>
                <Box sx={{ width: "70%", flexGrow: "1" }}>
                    {(props.taskTypeChart.taskChartType === AppChartType.BarChart
                        ? <BarChart
                            dataId={state.dataId}
                            labels={state.labels}
                            dataSets={state.dataSets}
                            yAxisValueFormatting={state.yAxisValueFormatting}
                            legendContainerId={legendContainerId.current}
                        />
                        : (props.taskTypeChart.taskChartType === AppChartType.PieChart
                            ? <PieChart
                                dataId={state.dataId}
                                labels={state.labels}
                                dataSets={state.dataSets}
                                legendContainerId={legendContainerId.current}
                            />
                            : <LineChart
                                dataId={state.dataId}
                                labels={state.labels}
                                dataSets={state.dataSets}
                                yAxisValueFormatting={state.yAxisValueFormatting}
                                legendContainerId={legendContainerId.current}
                            />
                        )
                    )}
                    
                </Box>
                <Box id={legendContainerId.current} sx={{ width: "30%", maxWidth: "200px", height: "100%", overflowY: "auto", overflowX: "hidden" }}> </Box>
            </Box>
        </Box>
    );
};
